<template>
  <div class="container" :data-corp-id="corpId">
      <div class="address_wrap">
         <ul>
           <li><label>收货人</label><div class="text-item"><input type="text" placeholder="姓名" v-model="addname" v-verify="addname"></div></li>
           <li><label>联系电话</label><div class="text-item"><input type="tel" placeholder="手机" maxlength="11" v-model="addphone" v-verify="addphone"></div></li>
           <!-- <li><label>选择地区</label>
            <x-address @on-hide="logHide" @on-show="logShow" :title="title" v-model="addressValue" :list="addressData" placeholder="地区信息" v-verify='addressValue'></x-address>
          <i class="arrow_right" ></i></li> -->

          <li>
                <label>选择地区</label>
                <AreaSelect @on-cancelArea="" @on-enterArea="enterArea" v-model="addressValue"   v-verify='addressValue'></AreaSelect>
          </li>
            

           <li class="address_textarea"><label>详细地址</label><div class="tarea"><textarea  placeholder="街道门牌信息" v-model="addAddress" v-verify="addAddress"></textarea></div></li>
         </ul>
         <div class="btn-wrap">
           <a href="javascript:;" class="btn btn-default" @click="addAddressFun">确认</a>
         </div>
      </div>
     <x-dialog v-model="tipDialog" class="dialog-pop" >
        <div class="content-wrap">
           <p>{{tipText}}</p>
        </div>
        <div class="btn-wraps"@click="tipDialog=false" >
          <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
        </div>
      </x-dialog>
       <home :ishome=0></home>
  </div>
</template>
<script>


import  Group  from 'vux/src/components/group/index.vue'
import  XAddress  from 'vux/src/components/x-address/index.vue'
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
import  PopupHeader  from 'vux/src/components/popup-header/index.vue'
import  Value2nameFilter  from 'vux/src/filters/value2name.js'
import AreaSelect from '../area-select/AreaSelect.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
      addressData:window.areaData,
      addressValue:[],
      title:'',
      loading:true,
      tipDialog:false,
      addname:'',
      addphone:'',
      addAddress:'',
      tipText:''

    }
  },
  components:{
    Group,
    XAddress,
    XDialog,
    home,
    AreaSelect
  },
  verify: {
        addname:"required",
        addphone: ["required","phone"],
        addAddress:"required",
        addressValue:"required"
    },
  computed:{       
     ...mapGetters({
      editAddress:'geteditAddressItem',
      editAddressStatus:'geteditAddressStatus',
      getUserInfo: 'getUserInfo',
    }),
    corpId(){
      return this.getUserInfo.corpId || '';
    },
    getName (value) {
      return Value2nameFilter(this.addressValue, window.areaData)
    },
  },
  watch:{
    editAddressStatus(cval){
      let bcval=cval.split('&')[0]
      if(bcval){
        this.$router.push({
          name:'address'
        })
      }

    }
  },
  beforeDestroy() {
    // 组件销毁时恢复默认标题
    this.$store.commit('CORP_CUSTOMIZE_ATTR', {
      data: {
        key: 'page_title_default',
        value: ''
      }
    })
  },
  created(){
    
  },
  methods:{
      enterArea:function(data){
        //   console.log(data,'enterArea')
      },
    showMsg(txt){
      this.tipText=txt;
      this.tipDialog=true;
    },
    logHide (str) {

    },
    logShow (str) {
    },
    addAddressFun(){
       if(!this.$verify.check()){
          console.log(this.$verify.$errors)
          if(this.$verify.$errors.addphone.length>0&&this.$verify.$errors.addname.length>0&&this.$verify.$errors.addressValue.length>0&&this.$verify.$errors.addAddress.length>0){
            this.showMsg('地址信息没填写')
            return;
          }
          if(this.$verify.$errors.addname.length>0){
            this.showMsg('请填写姓名')
            return;
          }
          if(this.$verify.$errors.addphone.length>0){
            if(this.$verify.$errors.addphone[0]=='手机号码格式不正确'){
              this.showMsg('手机号码格式不正确')
            }else{
              this.showMsg('请填写联系电话')
            }
            return;
          }
          if(this.$verify.$errors.addressValue.length>0){
            this.showMsg('请选择地区')
            return;
          }
          if(this.$verify.$errors.addAddress.length>0){
            this.showMsg('请填写详细地址')
            return;
          }

       }else{
          let adds=this.getName.split(' ');
          let params={
            address:this.addAddress,
            consignee:this.addname,
            mobile:this.addphone,
            provinceId:this.addressValue[0],
            province:adds[0],
            cityId:this.addressValue[1],
            city:adds[1],
            districtId:this.addressValue[2],
            district:adds[2]
          }
          let mparams=Object.assign({},this.editAddress,params)
          // console.log("doEditAddress",params)
          this.$store.dispatch('doEditAddress',mparams)
       }

    }
  },
  mounted(){
    this.$store.commit('CORP_CUSTOMIZE_ATTR', { 
        data: { 
          key: 'page_title_default', 
          value: '编辑地址',
        } 
    })
    // console.log("editAddress",this.editAddress)
    if(this.editAddress.provinceId){
        this.addname=this.editAddress.consignee;
        this.addphone=this.editAddress.mobile;
        this.addressValue=[this.editAddress.provinceId.toString(),this.editAddress.cityId.toString(),this.editAddress.districtId.toString()]
        this.addAddress=this.editAddress.address;
        
    }
    this.loading=false
  }
}
</script>